import { IoSettingsOutline } from 'react-icons/io5';

import { BlockData } from 'types';
import { NodeButtonView, NodeHeader, NodeNameView } from '../../ui';

interface DataNodeHeaderProps {
  data: BlockData;
  color: string;
  onInfoClick: () => void;
}

const DataNodeHeader = ({ data, color, onInfoClick }: DataNodeHeaderProps) => {
  return (
    <NodeHeader $color={color}>
      <NodeNameView>
        <span>{data.name}</span>
      </NodeNameView>
      <NodeButtonView>
        <button onClick={onInfoClick}>
          <IoSettingsOutline />
        </button>
      </NodeButtonView>
    </NodeHeader>
  );
};

export default DataNodeHeader;
